import React, { FC } from 'react';
import cx from 'classnames';
import useThemeBlock from '@/hooks/useThemeBlock';

import block from './block.json';
import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
export type ListProps = {
	ordered: boolean;
	values: string;
} & ThemeProps;

/**
 * COMPONENT
 */
export const List: FC<ListProps> & BlockConfigs = ({
	ordered,
	values,
	theme = {},
}) => {
	const { variant, blockTheme } = useThemeBlock(block.slug, theme);

	const htmlProps = {
		'data-variant': variant,
	};

	const rootClass = cx('supt-list', getStyles(blockTheme));

	return (
		<>
			{ordered ? (
				<ol
					className={rootClass}
					dangerouslySetInnerHTML={{ __html: values }}
					data-block={block.slug}
					{...htmlProps}
				/>
			) : (
				<ul
					className={rootClass}
					dangerouslySetInnerHTML={{ __html: values }}
					data-block={block.slug}
					{...htmlProps}
				/>
			)}
		</>
	);
};

List.slug = block.slug;
List.title = block.title;
